<button #trigger class="btn btn-primary btn-block dialog-trigger btn-filter w-100" (click)="launch()">
  <cx-icon [type]="iconTypes.FILTER"></cx-icon>
  {{ 'productList.filterBy.label' | cxTranslate }}
</button>

@if (isOpen$ | async) {
  <cx-facet-list
    [isDialog]="hasTrigger"
    (closeList)="close()"
    [classContainer]="'simple-card'"
    [class.active]="isActive$ | async"
    [class.dialog]="hasTrigger"
  ></cx-facet-list>
}
